<template>
  <div>
    <privilege-staff-info ref="privilegeStaffInfo"></privilege-staff-info>
    <el-row class="row">
      <el-col :span="16">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>权限列表</span>
          </div>
          <el-table
            :data="staffPrivilegeInfo.privileges"
            style="width: 100%"
            border
            stripe
          >
            <el-table-column prop="pId" label="权限ID" align="center"></el-table-column>
            <el-table-column prop="pName" label="权限名称" align="center"></el-table-column>
            <el-table-column prop="pgId" label="隶属权限组ID" align="center"></el-table-column>
            <el-table-column prop="pgName" label="隶属权限组名称" align="center"></el-table-column>
            <el-table-column label="状态" align="center">
              <template >
                <el-tag type="success">在用</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="_openDeleteStaffPrivilegeModel(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>树形结构</span>
          </div>
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            default-expand-all
          ></el-tree>
        </el-card>
      </el-col>
    </el-row>
    <delete-staff-privilege ref="deleteStaffPrivilege"></delete-staff-privilege>
  </div>
</template>

<script>
import PrivilegeStaffInfo from '@/components/frame/privilegeStaffInfo/privilegeStaffInfo'
import DeleteStaffPrivilege from '@/components/frame/deleteStaffPrivilege/deleteStaffPrivilege'
import { getStaffPrivileges } from '@/api/frame/staffPrivilegeApi'

export default {
  name: 'StaffPrivilege',
  components: {
    PrivilegeStaffInfo,
    DeleteStaffPrivilege
  },
  data() {
    return {
      staffPrivilegeInfo: {
        privileges: [],
        _currentStaffId: ''
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      total: 0
    }
  },
  methods: {
    _loadStaffPrivileges(_param) {
      this.staffPrivilegeInfo._currentStaffId = _param.staffId
      getStaffPrivileges({ staffId: _param.staffId })
        .then(response => {
          this.staffPrivilegeInfo.privileges = response.datas
          this._initTreeData(response.datas)
        })
        .catch(error => {
          console.log('请求失败处理', error)
        })
    },
    _openDeleteStaffPrivilegeModel(_staffPrivilege) {
      _staffPrivilege.staffId = this.staffPrivilegeInfo._currentStaffId
      this.$refs.deleteStaffPrivilege.open(_staffPrivilege)
    },
    _initTreeData(_privileges) {
      this.treeData = this._doTreeData(_privileges)
    },
    _doTreeData(_privileges) {
      console.log(_privileges)
      // 实现树形数据处理逻辑
      // ...
    },
    handleCurrentChange(val) {
      console.log(val)
    }
  },
  created() {
  }
}
</script>

<style scoped>
.row {
  width: 100%;
}
.pagination {
  margin-top: 15px;
  text-align: right;
}
.box-card {
  margin-bottom: 20px;
}
</style>